import { Modal, Typography, Input } from 'antd'
import Button from 'components/button/Button'
import { IconCancel } from 'components/icons'
import { useEffect, useState } from 'react'

interface IProps {
  isOpen: boolean
  setModal: (value: boolean) => void
  onClick: (isApproved: boolean, reason?: string) => Promise<void>
  loading: boolean
}

const ModalInvoiceConfirmation = (props: IProps) => {
  const { isOpen, setModal, loading, onClick } = props
  const [reason, setReason] = useState('')

  useEffect(() => {
    !isOpen && setReason('')
  }, [isOpen])

  return (
    <Modal
      data-testid="modal-sawitpoin-reject"
      open={isOpen}
      footer={null}
      onCancel={() => setModal(false)}
      closeIcon={<IconCancel strokeWidth="2" color="black" />}
    >
      <Typography.Paragraph className="text-lg text-[#364152] font-semibold">
        Alasan Penolakan
      </Typography.Paragraph>
      <Input.TextArea
        rows={4}
        placeholder="Tulis alasan"
        value={reason}
        data-testid="reason-textarea"
        onChange={e => setReason(e.currentTarget.value)}
      />
      <div className="flex justify-end">
        <Button
          onClick={() => onClick(false, reason)}
          data-testid="btn_send"
          className="inline-block font-bold uppercase text-primary mt-4"
          label="Kirim"
          variant="solid-primary"
          disabled={loading || reason.length < 4 || reason.trim().length === 0}
        />
      </div>
    </Modal>
  )
}

export default ModalInvoiceConfirmation
